import { useQuery } from "@tanstack/react-query"
import { profile } from "@shared/api/services";

export const useAlerts = () => {
    return useQuery({
        queryKey: ['alerts'],
        queryFn: () => profile.getAlerts(),
        select: (data) => data.data
    });
};